import { CountdownBannerBase } from "@faire/retailer-visitor-shared/components/CountdownBanner/__internal__/CountdownBannerBase";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { useEventsStore } from "@faire/retailer-visitor-shared/stores/domain/Events/shared/EventsStore";
import { ColorOrKey } from "@faire/web--source/slate/Color";
import { ThemeProvider } from "@faire/web--source/slate/Theme/ThemeProvider";
import { Typography } from "@faire/web--source/slate/Typography";
import { AlertBanner } from "@faire/web--source/ui/AlertBanner";
import { History } from "history";
import React, { useState } from "react";

export interface IProps {
  textColor?: ColorOrKey;
  DaysBeforeDeadlineView: (props: {
    daysLeft: number;
    timeLeft: string;
    mainEventRangeDate: string;
  }) => React.ReactNode;
  HoursBeforeDeadlineView: (props: { timeLeft: string }) => React.ReactNode;
  LoggedOutView: (props: {
    lastDay: boolean;
    mainEventRangeDate: string;
    history: History;
  }) => React.ReactNode;
  centerAlignIcon?: boolean;
}

export const CountdownBanner = ({
  textColor,
  DaysBeforeDeadlineView,
  HoursBeforeDeadlineView,
  LoggedOutView,
  centerAlignIcon,
}: IProps) => {
  const { nextOrActiveEventTheme } = useEventsStore(["nextOrActiveEventTheme"]);
  const { deadlineForCountdownBanner: deadline, hasCountdownEnded } =
    useMarketStore();
  const [showCountdown, setShowCountdown] = useState(() => !hasCountdownEnded);

  if (!showCountdown) {
    return null;
  }

  return (
    <ThemeProvider theme={nextOrActiveEventTheme}>
      <AlertBanner
        message={
          <Typography color={textColor}>
            <CountdownBannerBase
              // This key ensures we properly flip between live and not live event state.
              key={`${deadline}`}
              deadline={deadline}
              DaysBeforeDeadlineView={DaysBeforeDeadlineView}
              HoursBeforeDeadlineView={HoursBeforeDeadlineView}
              LoggedOutView={LoggedOutView}
              onCountdownChange={() => setShowCountdown(!hasCountdownEnded)}
            />
          </Typography>
        }
        centerAlignIcon={centerAlignIcon}
      />
    </ThemeProvider>
  );
};
